export default {
  name: 'integration',
  translationKey: 'integration-module',
  routePrefix: 'integration',
  routeNamePrefix: 'admin.integration',
  directRoutesAvailable: false,
}
